import { Link } from "react-router-dom";
import { InstagramLogo, WhatsappLogo, LinkedinLogo } from "@phosphor-icons/react";

// Ink footer to anchor the white body — like haus & haus / White & Co
export default function Footer() {
  const linkClass = "text-[#f8faff]/80 hover:text-white transition-colors";
  return (
    <footer className="bg-[#001588] text-[#f8faff]" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3 mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_penta-realty-uae/artifacts/lk46xfkn_Point%20Penta%20Logo%20png.png"
              alt="Point Penta"
              className="h-11 w-auto invert brightness-0 opacity-90"
            />
          </div>
          <p className="text-sm leading-relaxed max-w-xs text-[#f8faff]/80">
            Boutique Dubai brokerage. Curated residential, off-plan and commercial mandates across the emirate.
          </p>
          <div className="flex items-center gap-4 mt-6 text-[#f8faff]/80">
            <a
              href="https://www.instagram.com/pointpenta.ae?igsh=em1pMDJ4bHR3ZWZl"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="hover:text-white transition-colors"
            >
              <InstagramLogo size={20} />
            </a>
            <a
              href="https://ae.linkedin.com/company/point-penta-real-estate-llc"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin"
              className="hover:text-white transition-colors"
            >
              <LinkedinLogo size={20} />
            </a>
            <a
              href="https://wa.me/971557396664?text=Hi%20Point%20Penta%2C%20I%27d%20like%20to%20speak%20to%20an%20advisor."
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              data-testid="footer-whatsapp"
              className="hover:text-white transition-colors"
            >
              <WhatsappLogo size={20} />
            </a>
          </div>
        </div>

        <div>
          <div className="overline text-[#f8faff]/60 mb-5">Discover</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/properties" className={linkClass}>Buy</Link></li>
            <li><Link to="/rent" className={linkClass}>Rent</Link></li>
            <li><Link to="/projects" className={linkClass}>Off-plan</Link></li>
            <li><Link to="/commercial" className={linkClass}>Commercial</Link></li>
            <li><Link to="/areas" className={linkClass}>Communities</Link></li>
            <li><Link to="/developers" className={linkClass}>Developers</Link></li>
            <li><Link to="/faq" className={linkClass}>FAQ</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#f8faff]/60 mb-5">Services</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className={linkClass}>Sales & Advisory</Link></li>
            <li><Link to="/valuation" className={linkClass}>Free Valuation</Link></li>
            <li><Link to="/list-with-us" className={linkClass}>List with us</Link></li>
            <li><Link to="/calculators" className={linkClass}>Calculators</Link></li>
            <li><Link to="/journal" className={linkClass}>Journal</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-[#f8faff]/60 mb-5">Point Penta</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className={linkClass}>About</Link></li>
            <li><Link to="/agents" className={linkClass}>Team</Link></li>
            <li><Link to="/contact" className={linkClass}>Contact</Link></li>
            <li><Link to="/login" className={linkClass}>Agent portal</Link></li>
          </ul>
          <div className="mt-6 text-xs leading-relaxed text-[#f8faff]/70">
            902, Ithra Tower<br />
            Al Garhoud, Dubai, UAE<br />
            +971 55 739 6664<br />
            info@pointpenta.com<br />
            <span className="text-[#f8faff]/60 text-xs mt-2 inline-block">Mon–Sat · 9:00 a.m. – 7:00 p.m. GST</span>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-[#f8faff]/60">
          <span>© {new Date().getFullYear()} Point Penta Real Estate LLC. RERA ORN 12345.</span>
          <span>Regulated by the Dubai Land Department & RERA.</span>
        </div>
      </div>
    </footer>
  );
}
